import ninegrid from "../index.js";

class nxForm extends HTMLElement {
	#mode;

	constructor() {
		super();
		this.attachShadow({ mode: "open" });
	}

	connectedCallback() {
		this.#init();
	}

	getData_BAK = () => {
		const jsonData = {};

		this.shadowRoot.querySelectorAll("[id]").forEach(el => {
			if (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT") {
				jsonData[el.id] = el.value;
			} else {
				jsonData[el.id] = el.textContent.trim();
			}
		});

		return jsonData;
	};

	getData = () => {
		const jsonData = {};

		this.shadowRoot.querySelectorAll("input, textarea, select, [id], [name]").forEach(el => {
			const key = el.id || el.name; // id가 있으면 우선, 없으면 name 사용
			if (!key) return; // id도 name도 없으면 건너뛰기

			const value = (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT")
				? el.value
				: el.textContent.trim();

			// 중복 키를 대비한 배열 처리
			if (jsonData[key]) {
				if (!Array.isArray(jsonData[key])) {
					jsonData[key] = [jsonData[key]];
				}
				jsonData[key].push(value);
			} else {
				jsonData[key] = value;
			}
		});

		return jsonData;
	};


	#init = () => {

		const contents = this.innerHTML.trim();

		this.innerHTML = ""; // 기존 내부 HTML 제거
		const htmlTmpl = document.createElement("template");
		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxForm.css";
				${ninegrid.getCustomPath(this,"nxForm.css")}
			</style>
			
			${contents}
		`;

		this.shadowRoot.appendChild(htmlTmpl.content.cloneNode(true));
	};

}

if (!customElements.get('nx-form')) {
	customElements.define("nx-form", nxForm);
}
